import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { rawSnapshotSpecAtom, snapshotSpecBunja } from './state';
import { SnapshotSpec } from './utils';

const emptyObject = Object.freeze({}) as Partial<SnapshotSpec>;
export function useSnapshotSpec(): Partial<SnapshotSpec> {
  const { snapshotSpecAtom } = useBunja(snapshotSpecBunja);
  return useAtomValue(snapshotSpecAtom) || emptyObject;
}

export function useRawSnapshotSpec(): Partial<SnapshotSpec> {
  return useAtomValue(rawSnapshotSpecAtom) || emptyObject;
}
